<template>
    <UContainer class="bg-white p-8 mt-8 rounded leading-8">
        <UiComponentTypography class-name="mt-6" tag="h1"> توافق‌نامه حریم خصوصی کاربران </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">1. اطلاعات جمع‌آوری شده </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            نرس‌لند اطلاعاتی نظیر نام، آدرس، شماره تلفن، ایمیل، اطلاعات پرداخت و کوکی‌های شناسایی کاربر را جمع‌آوری
            می‌کند.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3"
            >2. نحوه استفاده از اطلاعات
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            اطلاعات جمع‌آوری شده به منظور پردازش سفارشات، ارسال محصولات، بهبود خدمات و ارسال پیامک‌ها و ایمیل‌های
            تبلیغاتی (در صورت تمایل کاربر) استفاده می‌شود.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">3. حفاظت از اطلاعات </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            تمامی اطلاعات کاربران به صورت رمزنگاری شده ذخیره و محافظت می‌شوند و نرس‌لند متعهد است تا از اطلاعات شخصی
            کاربران به بهترین نحو ممکن محافظت کند.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">4. اشتراک‌گذاری اطلاعات </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            نرس‌لند اطلاعات کاربران را با هیچ شخص ثالثی به اشتراک نمی‌گذارد.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3"
            >5. مدت زمان نگهداری اطلاعات
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            اطلاعات کاربران و خریدهای آنها برای همیشه در سیستم نرس‌لند نگهداری خواهد شد.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3"
            >6. حق انصراف از دریافت پیام‌های تبلیغاتی
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            کاربران در هر زمان می‌توانند از دریافت پیامک‌ها و ایمیل‌های تبلیغاتی انصراف دهند.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3"
            >7. تغییرات در سیاست حریم خصوصی
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            نرس‌لند حق دارد در هر زمان سیاست حریم خصوصی خود را تغییر دهد. هرگونه تغییر در این سیاست از لحظه انتشار در
            وب‌سایت اعمال خواهد شد و کاربران موظف به پذیرش آن هستند.
        </UiComponentTypography>
        <UiComponentTypography class-name="mt-6" tag="h2" variant="h3">8. تماس با ما </UiComponentTypography>
        <UiComponentTypography class-name="mt-4">
            در صورت وجود هرگونه سوال یا نگرانی درباره حریم خصوصی، کاربران می‌توانند از طریق روش‌های ارتباطی اعلام شده در
            وب‌سایت با نرس‌لند تماس بگیرند.
        </UiComponentTypography>
    </UContainer>
</template>

<script lang="ts" setup>
useSeoMeta({
    title: "حریم خصوصی کاربران | فروشگاه رستری قهوه نرس‌لند",
    description: "توافق‌نامه حفظ حریم خصوصی، نحوه جمع‌آوری، امنیت و حفاظت از اطلاعات کاربران در فروشگاه آنلاین نرس‌لند.",
    canonical: "https://northland-co.com/privacy-policy",
    ogTitle: "سیاست حفظ حریم خصوصی کاربران نرس‌لند",
    ogDescription: "تعهدات و سیاست‌های امنیتی نرس‌لند در خصوص حفظ داده‌های کاربران.",
    robots: "index, follow",
});
</script>

<style></style>
